/**
 * UUID/GUID format used by .NET (e.g. 550e8400-e29b-41d4-a716-446655440000).
 * Use for validating before sending to backend APIs (defense-in-depth with backend validation).
 */
const GUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isValidGuid(value: string | null | undefined): boolean {
  if (value == null || typeof value !== 'string') return false
  return GUID_REGEX.test(value.trim())
}
